import type { FaireProductEntity } from "../../entity_types/product";

export const starter_collection_37: FaireProductEntity = {
  token: "starter_collection_37",
  type: "product",
  name: "Le (Petit) Verre - Set of 4",
  brandName: "Sophie Lou Jacobsen",
  imageUrl: "",
  priceDollars: 78,
  msrpDollars: 156,
  description: "Migrated starter collections product",
  tags: ["starter-collections"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "playground-data-migration",
  },
};
